import * as actionTypes from '../action-types';

export const org_input=(orgBox)=>{
    return{
      type:actionTypes.ORG_PUT,
      orgBox
    }
}

export const lab_input=(labBox)=>{
    return{
      type:actionTypes.LAB_PUT,
      labBox
    }
}

export const group_input=(linkGroupBox)=>{
  return{
    type:actionTypes.GROUP_PUT,
    linkGroupBox
  }
}

export const piList_input=(piListBox)=>{
  return{
    type:actionTypes.PILIST_PUT,
    piListBox
  }
}

export const role_input=(roleBox)=>{
    return{
      type:actionTypes.ROLE_PUT,
      roleBox
    }
}

export const trainUser_input=(trainUserBox)=>{
    return{
      type:actionTypes.TRAINUSER_PUT,
      trainUserBox
    }
}

export const trainSpeaker_input=(trainSpeakerBox)=>{
  return{
    type:actionTypes.TRAIN_SPEAKER_PUT,
    trainSpeakerBox
  }
}

export const trainEndUser_input=(trainEndUserBox)=>{
  return{
    type:actionTypes.TRAINUSER_PUT,
    trainEndUserBox
  }
}

export const instrument_input=(instrumentBox)=>{
    return{
      type:actionTypes.INSTRUMENT_PUT,
      instrumentBox
    }
}

export const train_input=(trainBox)=>{
    return{
      type:actionTypes.TRAIN_PUT,
      trainBox
    }
}

export const trainlabel_input=(trainlabelBox)=>{
  return{
    type:actionTypes.TRAINLABEL_PUT,
    trainlabelBox
  }
}

export const personnelType_input=(roleListBox)=>{
  return{
    type:actionTypes.PERSONNELTYPE_PUT,
    roleListBox
  }
}
export const pisBox_input=(pisBox)=>{
  return{
    type:actionTypes.PISBOX_PUT,
    pisBox
  }
}


export const labRole_input=(labRoleBox)=>{
  return{
    type:actionTypes.LAB_ROLE_PUT,
    labRoleBox
  }
}

export const labUser_input=(labUserBox)=>{
  return{
    type:actionTypes.LAB_USER_PUT,
    labUserBox
  }
}

export const medicineBrand_input=(medicineBrandBox)=>{ //试剂耗材品牌
  return{
    type:actionTypes.MEDICINE_BRAND_PUT,
    medicineBrandBox
  }
}

export const medicineUnit_input=(medicineUnitBox)=>{ //试剂耗材单位
  return{
    type:actionTypes.MEDICINE_UNIT_PUT,
    medicineUnitBox
  }
}

export const medicineClassify_input=(medicineClassifyBox)=>{ //试剂耗材分类
  return{
    type:actionTypes.MEDICINE_CLASSIFY_PUT,
    medicineClassifyBox
  }
}

export const medicineAddress_input=(medicineAddressBox)=>{ //试剂耗材存放地
  return{
    type:actionTypes.MEDICINE_ADDRESS_PUT,
    medicineAddressBox
  }
}

export const medicineSupplier_input=(medicineSupplierBox)=>{ //试剂耗材供应商
  return{
    type:actionTypes.MEDICINE_SUPPLIER_PUT,
    medicineSupplierBox
  }
}

export const instrumentType_input=(instrumentTypeBox)=>{ //设备类型
  return{
    type:actionTypes.INSTRUMENT_TYPE_PUT,
    instrumentTypeBox
  }
}

export const instrumentBrand_input=(instrumentBrandBox)=>{ //设备品牌
  return{
    type:actionTypes.INSTRUMENT_BRAND_PUT,
    instrumentBrandBox
  }
}

export const instrumentAddress_input=(instrumentAddressBox)=>{ //设备存放地
  return{
    type:actionTypes.INSTRUMENT_ADDRESS_PUT,
    instrumentAddressBox
  }
}

